import * as Comlink from "comlink"
import SessionTimeout from "./sessionTimeout.worker?worker"
import { SessionTimeoutWorker } from "./sessionTimeout.worker"

const workers = {
    SessionTimeout() {
        const worker = new SessionTimeout();
        const obj = Comlink.wrap<SessionTimeoutWorker>(worker);
        return obj
    }
}

export default workers
